import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractControl, FormBuilder, UntypedFormControl } from '@angular/forms';

import {
    ExtendedBaseProfileField,
    FieldReadHelper,
    FormValue,
    FormValueState,
    MapFieldValue,
    ShComplexListInputFieldComponent,
    TypedValue
} from '@stylehaven/components';
import { isEmpty } from 'lodash-es';
import { debounceTime, take, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'med-address-input-list',
    templateUrl: './address-input-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressInputListComponent extends ShComplexListInputFieldComponent {
    constructor(
        protected fieldHelper: FieldReadHelper,
        protected formBuilder: FormBuilder
    ) {
        super(fieldHelper, formBuilder);
    }

    protected override initListChangeListener(
        profileField: ExtendedBaseProfileField,
        control: UntypedFormControl
    ): void {
        this.list.valueChanges.pipe(debounceTime(250), takeUntil(this.destroy$)).subscribe((formGroupValues: any[]) => {
            // Always UNSET all initial values
            const oldValues: any = this.initialValueList.map(value => new FormValue(value, FormValueState.UNSET));

            // Generate a ComplexMapFieldValue for each formGroupValue
            // In this case only the SET values are relevant since we already UNSET the initial values
            const newValues: FormValue<MapFieldValue>[] = formGroupValues
                .map(formGroupValue => {
                    if (Array.isArray(formGroupValue) && formGroupValue.length > 0) {
                        const addressValue: MapFieldValue = formGroupValue.reduce(
                            (acc: MapFieldValue, formValue: FormValue<TypedValue>) => {
                                acc[formValue.value.type] = formValue.value.value;
                                return acc;
                            },
                            {}
                        );
                        return !isEmpty(addressValue) ? { value: addressValue, state: FormValueState.SET } : null;
                    }
                    return null;
                })
                .filter((item): item is FormValue<MapFieldValue> => !!item);

            this.nestedIndex$.pipe(take(1), takeUntil(this.destroy$)).subscribe(nestedIndex => {
                if (nestedIndex === 0) {
                    // Only use set and unset for top-level fields
                    const values: FormValue<MapFieldValue>[] = [...oldValues, ...newValues];
                    control.setValue(values);
                } else {
                    control.setValue(newValues.map(value => value.value));
                }
            });
        });
    }

    // Need to override since the Address input component expects a control (not a FormGroup)
    protected override createFormGroup(): AbstractControl {
        return new UntypedFormControl();
    }
}
